/**
 * 通用：从 sys_enum 拉取选项（GET /shop/issueorder.enum/list），空或失败时使用兜底。
 * main_key 与库表 jjjshop_sys_enum.main_key 一致；可选种子见 database/shop_ui_enum_extensions.sql
 */

import request from '@/utils/request'

export const MAIN_KEY = {
  issueOrderListStatus: 'issue_order_list_status',
  issueOrderBizType: 'issue_order_biz_type',
  needListStatus: 'need_list_status',
  issueOrderDiffPayMethod: 'issue_order_diff_pay_method',
  issueOrderMortgageType: 'issue_order_mortgage_type',
  issueOrderCreditSelfEval: 'issue_order_credit_self_eval',
  secondhandDeliveryType: 'secondhand_delivery_type',
  secondhandProductStatus: 'secondhand_product_status',
  appraisalListStatus: 'appraisal_list_status',
}

export const FALLBACK_ISSUE_ORDER_STATUS_LIST = [
  { label: '待撮合', value: '10' },
  { label: '对单中', value: '40' },
  { label: '已完结', value: '20' },
  { label: '已关闭', value: '30' },
]

export const FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST = [
  { label: '项目需求', value: 'project' },
  { label: '置换需求', value: 'exchange' },
  { label: '投资需求', value: 'fund' },
  { label: '变现需求', value: 'cashout' },
  { label: '收购需求', value: 'acquisition' },
  { label: '租赁需求', value: 'rent' },
  { label: '借款需求', value: 'loan' },
]

export const FALLBACK_NEED_STATUS_LIST = [
  { label: '对单中', value: '10' },
  { label: '已完结', value: '20' },
  { label: '已关闭', value: '30' },
]

export const FALLBACK_DIFF_PAY_METHOD = [
  { value: 'me_cash', label: '我方补现金' },
  { value: 'other_cash', label: '对方补现金' },
]

export const FALLBACK_MORTGAGE_TYPE = [
  { value: 'house', label: '房产抵押' },
  { value: 'car', label: '车辆抵押' },
  { value: 'unsecured', label: '信用贷（无抵押）' },
]

export const FALLBACK_CREDIT_SELF_EVAL = [
  { value: 'normal', label: '普通' },
  { value: 'aaa', label: 'AAA优质' },
  { value: 'excellent', label: '资质优秀' },
]

export const FALLBACK_SECONDHAND_DELIVERY = [
  { label: '包邮', value: 1 },
  { label: '自提', value: 2 },
]

/** 含 el-tag type，与枚举合并时仅覆盖 label */
export const FALLBACK_SECONDHAND_PRODUCT_STATUS = [
  { label: '审核中', value: '10', type: 'warning' },
  { label: '已上架', value: '20', type: 'success' },
  { label: '已下架', value: '30', type: 'danger' },
]

export const FALLBACK_APPRAISAL_STATUS = [
  { label: '全部', value: '-1', type: 'info' },
  { label: '鉴定中', value: '0', type: 'primary' },
  { label: '已完成', value: '1', type: 'success' },
  { label: '已取消', value: '2', type: 'danger' },
]

export function fetchEnumRaw(mainKey, req = request) {
  return req._get('/shop/issueorder.enum/list', { main_key: mainKey }).then(res => {
    return (res.data && res.data.list) || []
  }).catch(() => [])
}

/**
 * @param {Array<{enum_key:string,enum_value:string}>} rows
 * @param {{ stringValue?: boolean, numberValue?: boolean }} opt
 */
export function mapEnumRowsToLabelValue(rows, opt = {}) {
  if (!rows || !rows.length) return []
  return rows.map(row => {
    let v = row.enum_key
    if (opt.numberValue) {
      const n = parseInt(String(row.enum_key), 10)
      v = Number.isNaN(n) ? row.enum_key : n
    } else if (opt.stringValue !== false) {
      v = String(row.enum_key)
    }
    return { label: row.enum_value || String(row.enum_key), value: v }
  })
}

export function fetchLabelValueOptions(mainKey, mapOpt, fallback, req = request) {
  return fetchEnumRaw(mainKey, req).then(rows => {
    const mapped = mapEnumRowsToLabelValue(rows, mapOpt)
    return mapped.length ? mapped : [...fallback]
  }).catch(() => [...fallback])
}

/**
 * 合并接口文案与本地 type 等扩展字段（按 value 对齐）
 */
export function fetchTaggedOptionsMerge(mainKey, fallbackTagged, req = request) {
  return fetchEnumRaw(mainKey, req).then(rows => {
    if (!rows || !rows.length) return fallbackTagged.slice()
    const fbByVal = {}
    fallbackTagged.forEach(f => {
      fbByVal[String(f.value)] = f
    })
    return rows.map(r => {
      const val = String(r.enum_key)
      const fb = fbByVal[val] || {}
      return {
        label: r.enum_value || r.enum_key,
        value: r.enum_key,
        type: fb.type,
      }
    })
  }).catch(() => fallbackTagged.slice())
}

export function labelFromOptions(options, value) {
  if (value === '' || value === null || typeof value === 'undefined') return ''
  const item = (options || []).find(o => String(o.value) === String(value))
  return item ? item.label : ''
}

export function bizTypeTextFromOptions(bizType, bizTypeList) {
  const t = labelFromOptions(bizTypeList, bizType)
  return t || bizType || ''
}



// WEBPACK FOOTER //
// ./src/utils/sysEnumOptions.js